import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NewUserCounter } from 'app/shared/models/class/counter/counter';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { CounterService } from 'app/shared/services/counter/counter.service';
import { UiService } from 'app/shared/services/ui/ui.service';

interface DialogData {
  action: string;
  user: any;
  userKey: number;
}

type switchOptions = {
  [key: string]: any
};

@Component({
  selector: 'app-open-dialog-add-edit-user',
  templateUrl: './open-dialog-add-edit-user.component.html',
  styleUrls: ['./open-dialog-add-edit-user.component.scss']
})
export class OpenDialogAddEditUserComponent implements OnInit {
  title: string;
  btnConfirm: string;
  addUserForm: UntypedFormGroup;
  userKey: number;
  confirm = false;

  constructor(
    public dialogRef: MatDialogRef<OpenDialogAddEditUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: UntypedFormBuilder,
    private counterService: CounterService,
    private authService: AuthService,
    private uiService: UiService,
  ) { }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
  }

  onSubmit(): void {
    const newUser = new NewUserCounter(this.f.lastName.value, this.f.firstName.value, this.f.email.value, this.f.phone.value);
    newUser.counterUserKey = this.userKey;

    this.counterService.createNewUser(newUser).subscribe({
      next: () => {
        this.confirm = true;
        setTimeout(() => {
          this.dialogRef.close();
        }, 2500);
      },
      error: error => console.error(error)
    });

  }

  private getLabel(type: string): string {
    const title: switchOptions = {
      add: {
        title: 'Ajouter un nouvel utilisateur',
        confirm: 'Ajouter'
      },
      edit: {
        title: 'Modifier l\'utilisateur',
        confirm: 'Mettre à jour'
      },
    };
    return title[this.data.action][type];
  }

  get f() {
    return this.addUserForm.controls;
  }

  private initForm(): void {
    this.addUserForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phone: ['', Validators.required],
      email: ['', Validators.email],
    });
  }

  private initComponent(): void {
    this.title = this.getLabel('title');
    this.btnConfirm = this.getLabel('confirm');
    this.userKey = +this.authService.getDecodedToken().sub;
  }

}
